module.exports = __webpack_public_path__ + "static/img/zx.0605545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introdution/zx.png
// module id = 2GlF
// module chunks = 1